import React, { useEffect } from 'react';
import { object } from 'prop-types';
import Store from '../../state/Store';
import { reportPageView } from '../../utils/report/bigquery';
import AssetsPageComponent from './component';

const AssetsPage = ({ seller, gig, assetsSharing }) => {
    useEffect(() => {
        reportPageView({ seller, gig, assetsSharing });
    }, [seller, gig, assetsSharing]);

    return (
        <div className="assets-sharing-page" data-testid="assets-sharing-page">
            <Store seller={seller} gig={gig} assetsSharing={assetsSharing}>
                <AssetsPageComponent />
            </Store>
        </div>
    );
};

AssetsPage.propTypes = {
    seller: object,
    gig: object,
    assetsSharing: object,
};

export default AssetsPage;
